import {
    IonCard,
    IonCardContent,
    IonCardTitle,
    IonCol,
    IonContent,
    IonLabel,
    IonPage,
    IonRow,
} from "@ionic/react";
import Header from "../../../../components/Headers/Header";
import PageTitle from "../../../../components/PageTitle/PageTitle";
import React, { useState } from "react";
import PeopleListEditor from "../../../../components/Admin/PeopleListEditor";
import AuditorListEditor from "../../../../components/Admin/AuditorListEditor";
import { FormGroup, Input } from "reactstrap";

const AdminPeoplePage: React.FC = () => {
    const [status, setStatus] = useState<string>("-");

    return (
        <IonPage className="bg-light">
            <Header />
            <IonContent>
                <PageTitle title="RSP Users" />
                <IonRow className="ion-justify-content-center">
                    <IonCol size="12">
                        <IonCard mode="md" className="ion-padding bg-white">
                            <IonCardTitle>Select Type</IonCardTitle>
                            <IonCardContent>
                                <IonRow>
                                    <IonCol>
                                        <FormGroup>
                                            <IonLabel>
                                                Type
                                            </IonLabel>
                                            <Input
                                                id="user-type-select"
                                                name="userTypeSelect" 
                                                type="select" 
                                                value={status} 
                                                onChange={e => {
                                                    setStatus(e.target.value);
                                                }}
                                            >
                                                <option>-</option>
                                                <option>Users</option>
                                                <option>Auditors</option>
                                            </Input>
                                        </FormGroup>
                                    </IonCol>
                                </IonRow>
                            </IonCardContent>
                        </IonCard>
                    </IonCol>
                </IonRow> 
                {status === "Users" && (
                    <IonRow className="ion-justify-content-center">
                        <IonCol size="12">
                            <IonCard mode="md" className="ion-padding bg-white">
                                <IonCardTitle>All Users</IonCardTitle>
                                <IonCardContent>
                                    <PeopleListEditor />
                                </IonCardContent>
                            </IonCard>
                        </IonCol>
                    </IonRow>
                )}
                {status === "Auditors" && (
                    <IonRow className="ion-justify-content-center">
                        <IonCol size="12">
                            <IonCard mode="md" className="ion-padding bg-white">
                                <IonCardTitle>All Auditors</IonCardTitle>
                                <IonCardContent>
                                    <AuditorListEditor />
                                </IonCardContent>
                            </IonCard>
                        </IonCol>
                    </IonRow>
                )}
            </IonContent>
        </IonPage>
    );
};

export default AdminPeoplePage;